import axios from 'axios'

const client = axios.create({
  baseURL: process.env.VUE_APP_API_URL || 'http://localhost:8000',
  withCredentials: true, // CORS Cookie送信に必須（CloudFront移行後も維持）
  headers: {
    'Content-type': 'application/json',
    Accept: 'application/json',
  },
})

// TEMPORARY: CloudFront移行後に削除 (Token認証 → Cookie認証に戻す)
// Add token to all requests
client.interceptors.request.use(
  (config) => {
    const token = localStorage.getItem('auth_token')
    if (token) {
      config.headers.Authorization = `Bearer ${token}`
    }
    return config
  },
  (error) => {
    return Promise.reject(error)
  }
)

// ログインが切れている（トークンが無効）とき、ログイン画面に戻す。
// 以前は 401 を画面ごとに握りつぶしていたため、LMS が「コースはありません」と空のまま表示され、
// 生徒からの問い合わせになっていた（2026-10）。
// ログイン API 自体の 401（パスワード違いなど）は画面側でメッセージを出すので対象外。
client.interceptors.response.use(
  (response) => response,
  (error) => {
    const url = error.config?.url || ''
    if (error.response?.status === 401 && localStorage.getItem('auth_token') && !url.includes('api/login')) {
      localStorage.removeItem('auth_token')
      localStorage.removeItem('logged_user_role') // stores/auth.js の LOGGED_USER_ROLE
      window.location.href = '/'
    }
    return Promise.reject(error)
  }
)

export default client
